import { IStringToString } from '../interfaces/core';
import { action, makeObservable, observable } from 'mobx';

class TranslationStore {

  translations: IStringToString = {
    PROMO_CLAIM_VOUCHER: 'Claim Voucher',
    PROMO_CODE_REQUIRED: 'Please enter a promo code',
    PROMO_ENTER_CODE: 'Enter Code',
    PROMO_VOUCHER_TEXT: 'Each voucher code can only be claimed once per user. Once it is claimed, the cannot be reversed.',
    PROMO_CLAIM: 'Claim',
    PROMO_CODE: 'Code',
    FREE_BET_END_CONTINUE: 'Continue',
    FREE_BET_END_TOTAL_PROFIT: 'Total profit you have collected',
    FREE_BET_END_NO_WIN: 'Better luck next time!',
    FREE_BET_END_NO_WIN_SUB: 'Your free bets did not result in a win this time.',
    FREE_BET_AWARD_CONGRATULATIONS: 'Congratulations',
    FREE_BET_AWARD_YOU_GET: 'You get {0} bonus spins',
    FREE_BET_AWARD_GOOD_LUCK: 'Good luck!',
    FREE_BET_AWARD_PLAY_NOW: 'Play now',
    FREE_BET_BADGE: 'Free Bet',
    FREE_BET_CLOSE: 'Close',
    FREE_BET_ICON_TROPHY_ALT: 'trophy',
    FREE_BET_ICON_GIFT_ALT: 'gift',
    PLATFORM_NOT_FOUND: 'Platform not found',
    GAME_NOT_FOUND: 'Game not found',
    PARTNER_NOT_FOUND: 'Partner not found',
    PARTNER_CONFIGURATION_NOT_FOUND: 'Partner Configuration not found',
    PLATFORM_CONFIGURATION_NOT_FOUND: 'Platform Configuration not found',
    MAINTENANCE_TEXT: 'We are currently undergoing technical improvements and will be back shortly. Please check again soon!',
    MAINTENANCE_DAYS: 'Days',
    MAINTENANCE_HOURS: 'Hours',
    MAINTENANCE_MINUTES: 'Minutes',
    MAINTENANCE_SECONDS: 'Seconds',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    CONNECTION_LOST: 'Connection lost',
    RECONNECT: 'Reconnect',
    SESSION_ENDED: 'Session ended',
    LOGGED_IN_ELSEWHERE: 'You have logged in on another device.',
    NETWORK_ERROR: 'We could not reach the server. Please check your internet connection.',
  };

  constructor() {
    makeObservable(this, {
      translations: observable,
      setTranslations: action,
    })
  }

  setTranslations = (translations: IStringToString) => {
    for (let translationsKey in translations) {
      this.translations[translationsKey] = translations[translationsKey];
    }
  }

  getTranslation = (key: string, ...params: (string | number)[]) => {
    let result = this.translations[key];
    if (result) {
      for (let i = 0; i < params.length; i++) {
        result = result.split('{' + i + '}').join(params[i].toString());
      }

      return result;
    }

    return key;
  }

}

export const translationStore = new TranslationStore();

export const useTranslation = () => translationStore.getTranslation;
